import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Immobile } from '../../../../models';

@Component({
  selector: 'app-dialog-immobile-cambia-stato',
  templateUrl: './dialog-immobile-cambia-stato.component.html',
  styleUrls: ['./dialog-immobile-cambia-stato.component.css']
})
export class DialogImmobileCambiaStato implements OnInit {
  immobile: Immobile;

  constructor(public dialogRef: MatDialogRef<DialogImmobileCambiaStato>,
    @Inject(MAT_DIALOG_DATA) public data: Immobile) 
  {
    this.immobile = data;
  }

  ngOnInit() {}

  si(){
    this.dialogRef.close(true);
  }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-immobile-cambia-stato/dialog-immobile-cambia-stato.component.ts